const trimRight = (value: string, pattern = '\\s') => value.replace(new RegExp(`[${pattern}]*$`), '');

export default trimRight;
